const fillEmptyResponse = (length, value) => new Array(length).fill(value);

export default fillEmptyResponse;
